import './survey.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import decodeToken from '../../../../utils/decode-token';
import Header from "../../../organisms/header/header";
import Wadsworth from "../../../organisms/role-hac/wadsworth/wadsworth";
import Footer from "../../../organisms/footer/footer";


function SurveyThankYou() {
  const { t } = useTranslation();

  const token = sessionStorage.getItem('token') || null;
  const decoded = token ? decodeToken(token) : null;
  const role = decoded?.role || null;


  return (
    <div className="App">
      <Header />
      <main className="legal">
        {role === 'hac' && <Wadsworth />}
        <section className="survey">
          <main className="main top questionary">
            <div className="inner-questionary">
              <div className="content">
                <div className="survey-content thank-you">
                  <br/>
                  <br/>
                  <br/>
                  <h2>Thank you</h2>
                  <p>{t('survey1-closing')}</p>
                  <br/>
                  <br/>


                </div>
              </div>

              <div className="photo thank-you"></div>
            </div>
          </main>
        </section>
      </main>
      <Footer />
    </div>

  );
}

export default SurveyThankYou;